import FormError from "./FormError";

const CustomInput = ({
  formik,
  label,
  placeholder,
  fieldName,
  className = "",
  style = "",
  disabled = false,
}: any) => {
  return (
    <div className={"col-12  col-lg-6 "} style={{ ...style }}>
      <label htmlFor="" className={`mb-2 form-label ${className} fw-bold`}>
        {label}
      </label>
      <input
        {...formik.getFieldProps(fieldName)}
        className={"form-control form-control-lg form-control-solid "}
        placeholder={placeholder}
        disabled={disabled}
      />
      <FormError formik={formik} fieldName={fieldName} />
    </div>
  );
};

export default CustomInput;
